import React, { useState } from "react";
import { BiChevronRight } from "react-icons/bi";

const BackTop = () => {
  const [visible, setVisible] = useState(false);
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  window.addEventListener("scroll", toggleVisible);
  return (
    <>
      <div
        className="BackTop"
        onClick={scrollToTop}
        style={{ opacity: visible ? "1" : "0" }}
      >
        <BiChevronRight />
      </div>
    </>
  );
};

export default BackTop;
